import { useTabPanel } from '@react-aria/tabs'
import { useObjectRef } from '../../utils/useObjectRef'
import { TabListState } from '@react-stately/tabs'
import { AriaTabPanelProps } from '@react-types/tabs'
import Styles from './TabPanel.module.scss'
import { forwardRef } from 'react'

interface Props<T> extends AriaTabPanelProps {
  state: TabListState<T>
}

export const TabPanel = forwardRef<HTMLDivElement, Props<HTMLDivElement>>(({ state, ...props }, fRef) => {
  const ref = useObjectRef<HTMLDivElement>(fRef)
  const { tabPanelProps } = useTabPanel(props, state, ref)
  return (
    <div {...tabPanelProps} ref={ref} data-tab={state.selectedItem?.key} className={Styles.tabPanel}>
      {state.selectedItem?.props.children}
    </div>
  )
})
